<!--
 * Created by JackCui on 2021/12/2
 -->
<template>
  <div>
    <slot :node="node" name='head'></slot>
    <slot :node="node"></slot>
  </div>
</template>

<script>
  export default {
    name: 'page',
    props: {
      node: Object
    }
  }
</script>

<style scoped>
</style>
